testWebPSupport();
polyfillElement();
polyfillUint8Array();

function polyfillUint8Array() {
    if (Uint8Array.prototype.reduce) return;

    Uint8Array.prototype.reduce = Array.prototype.reduce;
}

function polyfillElement() {
    [Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach(function(item) {
        if (item.hasOwnProperty("remove")) {
            return;
        }

        Object.defineProperty(item, "remove", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                if (this.parentNode !== null)
                    this.parentNode.removeChild(this);
            }
        });
    });
}

function testWebPSupport() {
    window.webp = false;

    var image = new Image();
    image.onload = function() {
        window.webp = image.width === 1;
    }
    image.src = "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=";
};